import { render, staticRenderFns } from "./allShow2.vue?vue&type=template&id=29f0a42c&scoped=true"
import script from "./allShow2.vue?vue&type=script&lang=js"
export * from "./allShow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f0a42c",
  null
  
)

export default component.exports